const uploadSelfie = async (payload: { user: string; imageBS64: string; essential_only: boolean; }) => {
    try {
        const response = await fetch('https://service.tangent.ai/shopify/v2/upload-selfie', {
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            return await response.json();
        } else {
            const errorData = await response.json();
            return Promise.reject(errorData);
        }
    } catch (error) {
        return Promise.reject(error);
    }
}

export default uploadSelfie;


// import axios from "axios";

// const uploadSelfie = async (payload) => {
//     const response = await axios.post('https://service.tangent.ai/shopify/v2/upload-selfie', payload);
//     return response.data;
// }